<template>
  <div>
    <save-engagement-tool
      :pageHeadingInfo="pageHeadingInfo"
      :leftToolSummary="leftToolSummary"
      :rightToolSummary="rightToolSummary"
      :chartTabContent="chartTabContent"
      :chartProperties="chartProperties"
      :selectedComponent="selectedComponent"
      :chartData="chartGraphData"
      :fieldInfo="fieldInfo"
      @cancelInstance="cancelInstance"
      @saveInstance="saveInstance"
      @onBack="onBack"
      @onChangeChartTab="onChangeChartTab"
    ></save-engagement-tool>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="dialogButtonClock"
    ></confirmation-dialog>
  </div>
</template>

<script>
import { SaveEngagementTool } from "../../component/loan";
import { ConfirmationDialog } from "../../component/tool";
import { InvestmentEngagementTool } from "../../mixin";
import { ICELoanIntegration, UserEvent } from "../../mixin";
import { InvestmentSelected, SaveAsAction } from "../../helpers/userEvent";
import {
  GET_INVESTMENT_CHART_MODEL,
  GET_SELECTED_INVESTMENT_INFORMATION,
  SET_NOTIFICATION_SUMMARY,
  GET_INVESTMENT_INFORMATION,
  SET_PROJECTION_API_RESPONSE,
  SET_INVESTMENT_CHART_MODEL,
  SET_SELECTED_INVESTMENT_INFORMATION,
  SET_LOADER_VISIBILITY,
  GET_PROJECTION_MODEL,
} from "../../helpers/vuex-constants";
import { mapGetters, mapActions } from "vuex";
import { InvestmentService } from "../../services";
export default {
  components: {
    SaveEngagementTool,
    ConfirmationDialog,
  },
  data() {
    return {
      fieldInfo: {
        label: "Investment Name",
        error: false,
        errorText: [],
        value: "",
        maxValue: 60,
      },

      pageHeadingInfo: {
        heading: "Name the instance",
        headingIconText: " test hover",
        subHeading: "Make it short and descriptive so you can easily identify",
      },

      leftToolSummary: [{ key: "Net CashFlow", value: "View Details" }],

      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "cancelButtonDialogDiscard_Click",
              id: 2,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "cancelButtonDialogSave_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  mixins: [InvestmentEngagementTool, ICELoanIntegration, UserEvent],
  mounted() {
    this.projectionYear.Value = this.selectedInvestmentData.projectionYear;
    this.RemapGraphsModel();
    this.setLoanName();
  },
  async created() {},
  computed: {
    ...mapGetters("investment", {
      selectedInvestmentData: GET_SELECTED_INVESTMENT_INFORMATION,
      projectionModel: GET_INVESTMENT_CHART_MODEL,
      projectionAPIResponse: GET_PROJECTION_MODEL,
      getInvestmentInformation: GET_INVESTMENT_INFORMATION,
    }),
  },
  methods: {
    ...mapActions("investment", {
      setSelectedInvestmentInfo: SET_SELECTED_INVESTMENT_INFORMATION,
    }),
    setLoanName() {
      this.fieldInfo.value = "";
    },

    cancelInstance() {
      this.confirmationDialogList[0].toggle = true;
    },
    dialogButtonClock(function_name) {
      this[function_name]();
    },
    saveInstance() {
      this.saveData();
    },
    onBack() {
      this.selectedInvestmentData.amount =
        this.selectedInvestmentData.investmentAmount;
      this.selectedInvestmentData.durationTypeId =
        this.selectedInvestmentData.frequencyId;
      this.selectedInvestmentData.isNotShowEmptyState = true;
      this.selectedInvestmentData.platformId =
        this.selectedInvestmentData.platformid;
      this.setSelectedInvestmentInfo(this.selectedInvestmentData);
      this.$router.push({ name: "investment-engagement-tool" });
    },
    cancelButtonDialogDiscard_Click() {
      this.selectedInvestmentData.amount =
        this.selectedInvestmentData.investmentAmount;
      this.selectedInvestmentData.durationTypeId =
        this.selectedInvestmentData.frequencyId;
      this.selectedInvestmentData.isNotShowEmptyState = true;
      this.selectedInvestmentData.platformId =
        this.selectedInvestmentData.platformid;
      this.$router.push({ name: "investment-engagement-tool" });
    },

    ValidateInstanceName() {
      let instanceName = this.fieldInfo.value;
      if (this.fieldInfo.value == "" || this.fieldInfo.value.trim() == "") {
        this.fieldInfo.value = "";
        this.fieldInfo.error = true;
        this.fieldInfo.errorText = ["Please Enter Instance Name"];
        return false;
      }
      var isExistName = this.getInvestmentInformation.findIndex(
        (sr) =>
          (!sr.description ? "" : sr.description.toUpperCase().trim()) ==
          instanceName.toUpperCase().trim()
      );
      if (isExistName >= 0) {
        this.fieldInfo.error = true;
        this.fieldInfo.errorText = ["Instance Name aleady exist."];
        return false;
      }
      return true;
    },

    async saveData() {
      let isValid = this.ValidateInstanceName();
      let isUpdate = 0;
      if (isValid) {
        this.selectedInvestmentData.description = this.fieldInfo.value;
        this.selectedInvestmentData.Platform = this.fieldInfo.value;

        let projectionAPIResponse = this.projectionAPIResponse;
        this.setLoaderVisibility(true);

        var apiResponse = await InvestmentService.saveAsInvestmentInformation(
          this.selectedInvestmentData,
          projectionAPIResponse
        );
        this.setLoaderVisibility(false);
        this.saveUserSession(
          InvestmentSelected,
          SaveAsAction,
          this.selectedInvestmentData.investmentClassID
        );
        this.saveInvestmentData(
          apiResponse,
          this.selectedInvestmentData,
          isUpdate
        );
      }
    },
    async cancelButtonDialogSave_Click() {
      this.saveData();
    },

    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("investment", {
      setProjectionApiResponse: SET_PROJECTION_API_RESPONSE,
      setInvestmentChartModel: SET_INVESTMENT_CHART_MODEL,
    }),
  },
  destroyed() {
    this.setProjectionApiResponse({});
    this.setInvestmentChartModel({});
  },
};
</script>

<style lang="scss" scoped></style>
